import { CapabilityApi } from 'api/';
import { getApiActionCreator } from 'helpers/actionHelper';
import { NEWCAPABILITIES, apiCallStatus } from 'helpers/constants';
import { getGeneralFilteredAssetsV2 } from 'helpers/selectors';
export { getAssetDetailsV2 } from '../DetailedInformation/actions';
import { actionTypes } from '../constants';
export { getSubscriptionInfo } from '../../PowertrainTools/SubscriptionStatus/actions';

export const setSelectedPowertrain = (powertrain) => ({ type: actionTypes.SET_SELECTED_POWERTRAIN, powertrain });
export const setSelectedAsset = (asset) => ({ type: actionTypes.SET_SELECTED_ASSET, asset });

export const getSelectedPowertrainById = (powertrainId, powertrains) => {
    return (dispatch) => {
        if (powertrains) {
            const selectedPowertrain = powertrains?.find((powertrain) => powertrain?.powertrainId?.toString() === powertrainId) || null;
            dispatch(setSelectedPowertrain(selectedPowertrain));
        }
    };
};

export const getSelectedAssetFromPowertrainById = (assetId) => {
    return (dispatch, getState) => {
        const selectedPowertrain = getState().powertrainAssetDetails?.selectedPowertrain;
        const assets = getGeneralFilteredAssetsV2(getState());
        if (selectedPowertrain) {
            const selectedAsset = assets?.find(
                (asset) => asset?.id?.toString() === assetId || asset?.serialNumber && asset?.serialNumber?.toLowerCase() === assetId?.toLowerCase()
            ) || null;
            dispatch(setSelectedAsset(selectedAsset));
        }
    };
};

export const getSelectedAssetById = (assetId) => {
    return (dispatch, getState) => {
        const assets = getGeneralFilteredAssetsV2(getState());
        if (assets) {
            const selectedAsset = assets?.find(
                (asset) => asset?.id?.toString() === assetId || asset?.serialNumber && asset?.serialNumber?.toLowerCase() === assetId?.toLowerCase() || asset?.assetId?.toString() === assetId
            ) || null;
            dispatch(setSelectedAsset(selectedAsset));
        }
    };
};

export const resetAssetAndPowerTrainSelection = () => {
    return dispatch => {
        dispatch(setSelectedPowertrain(null));
        dispatch(setSelectedAsset(null));
    };
};
const getNewCapabilitiesAction = getApiActionCreator(actionTypes.GET_ASSET_NEWCAPABILITIES);
export const getApiAssetCapability = (asset) => {
    return (dispatch, getState) => {
        const selectedAsset = getState().powertrainAssetDetails?.selectedAsset;
        // Check if the selected asset ID matches the provided asset ID.
        // This ensures that capabilities are fetched only for the currently selected asset,
        // avoiding unnecessary API calls or potential data mismatches.
        if (selectedAsset?.id !== asset?.id) {
            return;
        }
        const organizationId = getState().generalFilter?.selectedFilters?.organizations[0]?.organizationID;
        const capabilityCodes = Object.values(NEWCAPABILITIES);
        dispatch(getNewCapabilitiesAction(apiCallStatus.LOADING));
        return CapabilityApi.getCapabilities(organizationId, [asset?.id], capabilityCodes)
            .then((capabilities) => {
                dispatch(getNewCapabilitiesAction(apiCallStatus.SUCCESS, capabilities));
            })
            .catch((err) => {
                dispatch(getNewCapabilitiesAction(apiCallStatus.ERROR, [], err));
            });
    };
};

export const getAssetConditionIndicesRequest = (request) => ({
    type: actionTypes.LOAD_ASSET_CONDITION_INDICES_REQUEST,
    request
});

export const clearStore = () => {
    return (dispatch) => {
        dispatch({ type: actionTypes.CLEAR_STORE });
    };
};
